import React from "react";

type BadgeProps = {
  color: string;
  textColor?: string;
  bold?: boolean;
  fullWidth?: boolean;
  size?: "small" | "medium" | "large" | "xsmall";
  children: React.ReactNode;
  padding?: number;
  width?: number;
  onClick?: () => void;
};

const BadgeCustom: React.FC<BadgeProps> = ({
  color = "gray",
  textColor = "",
  size = "small",
  children,
  bold = true,
  fullWidth = false,
  padding = 0.2,
  width = 0,
  onClick
}) => {
  // Define consistent height + padding
  const height =
    size === "xsmall" ? 14 :
      size === "small" ? 18 :
        size === "medium" ? 22 :
          26;

  const fontSize =
    size === "small" ? "0.7rem" :
      size === "medium" ? "0.8rem" :
        "0.9rem";
  const isHexColor = color?.startsWith('#');
  const isHexText = textColor?.startsWith('#');

  const weight = bold ? 600 : 300;

  return (
    <>
      <style>{`
        .badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: ${fullWidth ? "100%" : (width ? `${width}px` : "auto")};
          min-width: ${fullWidth ? "" : height};
          
          height: ${height}px;
          padding: ${padding}rem;
          border-radius: ${height / 4}px; /* pill shape */
          text-align: center;
          margin: 0.2rem;
          color: white;
          white-space: nowrap;
        }
        .badge.red { background-color: #ed1622; }
        .badge.purple { background-color: #e6bde5; color:black }
        .badge.pink { background-color: #f36493 }
        .badge.indigo { background-color: #9caad8; }
        .badge.cyan { background-color: #bbebf0; color:black }
        .badge.lime { background-color: #d0d962; color:black }
        .badge.orange { background-color: #ff9528; }
        .badge.brown { background-color: #a58b84; }
        .badge.violet { background-color: #7a59bc }
        .badge.dark { background-color: #2b383e }
        .badge.smoke { background-color: #4a6b78 }
        .badge.neon { background-color: #88c241 }
        .badge.light { background-color: #d6d9da; color:black }
        .badge.lightgreen { background-color: #b2e1da; color:black }
        .badge.green { background-color: #43a047; }
        .badge.blue { background-color: #1e88e5; }
        .badge.yellow { background-color: #fbc02d; color: black; }
        .badge.grey { background-color: #757575; }
      `}</style>

      <span
        className={`badge ${!isHexColor ? color : ''}`}
        onClick={onClick}
        style={{
          cursor: onClick ? "pointer" : "default",
          fontSize,
          fontWeight: weight,
          backgroundColor: isHexColor ? color : undefined,
          color: isHexText ? textColor : undefined
        }}
      >
        {children}
      </span>
    </>
  );
};

export default BadgeCustom;
